import { create } from 'zustand';
import * as judgmentsApi from './judgmentsApi';
import type { Judgment } from './judgmentsApi';

export type { Judgment };

interface JudgmentsState {
  judgments: Judgment[];
  loading: boolean;
  /** Set when the last fetch failed, so a screen can say so instead of rendering "no judgments".
   *  Cleared at the start of every fetch. Mirrors diaryStore / documentsStore. */
  error: string | null;
  fetchJudgments: () => Promise<void>;
  /** Deliberately no deleteJudgment: it was fire-and-forget — the row left the screen before the
   *  server answered, and a refusal was logged to the console and silently rolled back, so the
   *  caller could never tell the user. Screens call judgmentsApi.deleteJudgment directly, await
   *  it, and refetch (JudgmentsPage.tsx:239-244). Any store action added here must return a
   *  promise that rejects. */
}

export const useJudgmentsStore = create<JudgmentsState>()((set) => ({
  judgments: [],
  loading: false,
  error: null,

  fetchJudgments: async () => {
    set({ loading: true, error: null });
    try {
      const judgments = await judgmentsApi.fetchJudgments();
      set({ judgments, loading: false, error: null });
    } catch (err) {
      console.error('Failed to fetch judgments:', err);
      set({ loading: false, error: 'Judgments could not be loaded' });
    }
  },
}));
